(function (angular, app) {
   "use strict";
   
   // Def
   app.modules.view = {
       name: "app.View"
       , directives: {
           welcome: "ggWelcomeDirective"
           , faq: "ggFaqDirective"
           , my: "ggMyDirective"
           , mbwa: "ggMbwaDirective"
           , mbwaUrl: "ggMbwaUrl"
       }
      , routes : {
         intro: {
            path: "/"
            , controller: "gg_IntroController"
            , controllerAs: "ggIntroCtrl"
            , templateUrl: "app/view/controllers/intro.html"
            , features: {
               showHeading: true
               , showBackgroundImg: true
            }
            , accessControl: {
               roles: ["ANONYMOUS"]
                , roleCheckType: 1
            }
         }
         , invalid: {
             path: "/invalid"
            , controller: "gg_InvalidRequestController"
            , controllerAs: "ggInvalidCtrl"
            , templateUrl: "app/view/controllers/invalid.html"
            , features: {
                showHeading: true
            }
         }
          , privacy: {
              path: "/privacy"
            , controller: "gg_PrivacyController"
            , controllerAs: "ggPrivacyCtrl"
            , templateUrl: "app/view/controllers/privacy.html"
            , features: {
                showHeading: true
            }
          }
         , accessdenied : {
            path : "/accessdenied"
            , controller : "gg_AccessDeniedController"
            , controllerAs : "ggAccessDeniedCtrl"
            , templateUrl : "app/view/controllers/accessdenied.html"
            , features : {
               showHeading : true
            }/*
            , accessControl : {
               roles : ["MEMBER"]
                , roleCheckType : app.modules.core.types.roleCheckType.atLeastOne
            }*/
         }
         , register: {
             path: "/register"
            , controller: "gg_RegisterController"
            , controllerAs: "ggRegisterCtrl"
            , templateUrl: "app/view/controllers/register.html"
            , features: {
                showHeading: true
               , bodyClass: "body-photo"
            }
            , accessControl: {
                roles: ["ANONYMOUS"]
                , roleCheckType: 1
            }
         }
          , comingsoon: {
              path: "/comingsoon"
            , controller: "gg_ComingSoonController"
            , controllerAs: "ggComingSoonCtrl"
            , templateUrl: "app/view/controllers/comingsoon.html"
            , features: {
                showHeading: true
            }
          }
      }
       , templates: {
           external : "app/view/directives/external.html"
       }
   };

   angular.module(app.modules.view.name, [
        "ngRoute"
        , "ngTouch"
        , "ngDialog"
        , "ui.bootstrap"
        , "angular-loading-bar"
        , app.modules.common.name
        , app.modules.member.name
        , app.modules.ui.name
   ]);
}(angular, app));
